"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const rxjs_1 = require("rxjs");
const auth_events_1 = __importDefault(require("./auth.events"));
const AUTH_DEFAULT_ROUTE = '/';
const AUTH_REDIRECT_STORAGE = 'AUTH_REDIRECT_STORAGE';
const AUTH_STORAGE = 'cas-js:user';
const BOOSTRAP_CONFIG_DEFAULT_OPTIONS = {
  signinRedirect: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true
};
class Bootstrap {
  constructor(authService, config) {
    this.config = Object.assign(Object.assign({}, BOOSTRAP_CONFIG_DEFAULT_OPTIONS), config);
    this.authService = authService;
    this.subject = new rxjs_1.Subject();
    this.subscribe = this.subject.subscribe.bind(this.subject);
    this.unsubscribe = this.subject.unsubscribe.bind(this.subject);
    this.authRenewRoute = new URL(this.authService.userManager.settings.silent_redirect_uri).pathname;
    this.authLoginRoute = new URL(this.authService.userManager.settings.redirect_uri).pathname;
    this.authLogoutRoute = new URL(this.authService.userManager.settings.post_logout_redirect_uri).pathname;
    this.authRoutes = [this.authRenewRoute, this.authLoginRoute, this.authLogoutRoute];
    this.accessTokenExpiringListener = () => auth_events_1.default.dispatchRenew();
    this.silentRenewErrorListener = () => auth_events_1.default.dispatchRenewError();
    this.userLoadedListener = () => {
      if (location.pathname === this.authLoginRoute) this.getUser();else this.authenticate();
    };
    this.visibilityChangeListener = () => {
      if (document.visibilityState === 'visible') {
        this.authenticate();
      }
    };
  }
  start() {
    let newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.config = Object.assign(Object.assign({}, this.config), newConfig);
    this.authenticate();
    if (this.authService.userManager.settings.automaticSilentRenew) {
      this.authService.userManager.startSilentRenew();
      this.authService.userManager.events.addSilentRenewError(this.silentRenewErrorListener);
    }
    this.authService.userManager.events.addAccessTokenExpiring(this.accessTokenExpiringListener);
    this.authService.userManager.events.addUserLoaded(this.userLoadedListener);
    if (this.config.revalidateOnReconnect) {
      window.addEventListener('online', this.authenticate);
    }
    if (this.config.revalidateOnFocus) {
      document.addEventListener('visibilitychange', this.visibilityChangeListener);
    }
  }
  stop() {
    if (this.authService.userManager.settings.automaticSilentRenew) {
      this.authService.userManager.stopSilentRenew();
      this.authService.userManager.events.removeSilentRenewError(this.silentRenewErrorListener);
    }
    this.authService.userManager.events.removeAccessTokenExpiring(this.accessTokenExpiringListener);
    this.authService.userManager.events.removeUserLoaded(this.userLoadedListener);
    if (this.config.revalidateOnReconnect) {
      window.removeEventListener('online', this.authenticate);
    }
    if (this.config.revalidateOnFocus) {
      document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }
  }
  authenticate() {
    return __awaiter(this, void 0, void 0, function* () {
      if (new URLSearchParams(location.search).get('error') === 'login_required') {
        this.logout();
        return;
      }
      if (location.pathname === this.authRenewRoute || location.pathname === this.authLoginRoute) {
        yield this.authService.signinCallback().catch(() => this.signinRedirect());
      }
      if (location.pathname === this.authLogoutRoute) {
        yield this.authService.signoutCallback();
        const redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE);
        window.location.href = redirectRoute || AUTH_DEFAULT_ROUTE;
        return;
      }
      if (this.authRoutes.indexOf(location.pathname) >= 0) {
        const redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE);
        window.location.href = redirectRoute || AUTH_DEFAULT_ROUTE;
        sessionStorage.removeItem(AUTH_REDIRECT_STORAGE);
        return;
      }
      this.getUser();
    });
  }
  signinSilent() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        auth_events_1.default.dispatchRenew();
        const user = yield this.authService.signinSilent();
        return user;
      } catch (e) {
        this.signinRedirect();
        return null;
      }
    });
  }
  signinRedirect() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.config.signinRedirect) return;
      const currRoute = this.getCurrentRoute();
      localStorage.removeItem(AUTH_STORAGE);
      sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
      yield this.authService.signinRedirect();
    });
  }
  getUser() {
    return __awaiter(this, void 0, void 0, function* () {
      let user = yield this.authService.getUser();
      if (!user) yield this.signinRedirect();
      if ((user === null || user === void 0 ? void 0 : user.expired) || !user && !this.config.signinRedirect) user = yield this.signinSilent();
      if (user) localStorage.setItem(AUTH_STORAGE, JSON.stringify(user));
      this.subject.next(user);
      auth_events_1.default.dispatchUser(user);
      return user;
    });
  }
  logout() {
    return __awaiter(this, void 0, void 0, function* () {
      const currRoute = this.getCurrentRoute();
      localStorage.removeItem(AUTH_STORAGE);
      sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
      yield this.authService.signoutRedirect();
    });
  }
  getCurrentRoute() {
    return this.authRoutes.indexOf(location.pathname) < 0 ? `${location.pathname}${location.search}` : AUTH_DEFAULT_ROUTE;
  }
}
exports.default = Bootstrap;